module.exports = __webpack_public_path__ + "img/castellum_tech_Normal_ua.68b6dd5b.webp";